import React, { useState } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { agent } from "../agent";
import PaymentCancelPage from "../pages/PaymentCancel";
import { URL_PATHS } from "../routes";
import { OtherPaymentMethod } from "../generated/lib-domain/iap";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../store";
import { myDataActions } from "../store/myData";
import { smartAlert } from "../lib/confirm-alert";

const PaymentCancelContainer = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { paymentStatus, myUser } = useSelector((state: AppState) => ({
        paymentStatus: state.payment.status,
        myUser: state.myData.user
    }));
    const canCancel = myUser.isPaid && !paymentStatus.paidFinishDate;
    if (!canCancel) {
        return <Redirect to={URL_PATHS.myPage()} />;
    }

    const [isLoading, setIsLoading] = useState(false);
    async function onPaymentCancel() {
        setIsLoading(true);
        try {
            if (
                paymentStatus.primaryPaymentMethod ===
                OtherPaymentMethod.CREDIT_CARD
            ) {
                await agent.putPaymentStopPaidMember();
                dispatch(myDataActions.myDataShouldLoadSet(true));
                setIsLoading(false);
                history.replace(URL_PATHS.paymentCancelFinish());
            }
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
            await smartAlert("有料プランの停止処理に失敗しました。");
        }
    }
    return (
        <PaymentCancelPage
            onPaymentCancel={onPaymentCancel}
            isLoading={isLoading}
        />
    );
};

export default PaymentCancelContainer;
